import { getMediaUrl } from "@/constants";
import { Context } from "@/context";
import { useDicePreviewerStore } from "@/hooks/useDicePreviewerStore";
import type { Manifest } from "@/types";
import { useTexture } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { useContext } from "react";
import { RepeatWrapping, type Texture } from "three";

const FALLBACK_PIXEL_TEXTURE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

export const useTextures = (
  setName: string,
  textureResources: Manifest["resources"]["textures"],
) => {
  const { gl } = useThree();
  const maxAnisotropy = gl.capabilities.getMaxAnisotropy();
  const { nodeEnv: ne, env: e } = useContext(Context);
  const nodeEnv = ne || JSON.parse(self.name).nodeEnv;
  const env = e || JSON.parse(self.name).env;
  const mediaUrl = getMediaUrl(nodeEnv, env);
  const customUrlMap = useDicePreviewerStore((state) => state.customUrlMap);

  const onLoad = (textures: Record<string, Texture>) => {
    Object.values(textures).forEach((texture) => {
      texture.flipY = false;
      texture.anisotropy = maxAnisotropy;
      texture.wrapS = texture.wrapT = RepeatWrapping;
    });
  };

  const urls: Record<string, string> = {};
  Object.entries(textureResources).forEach(([definition, path]) => {
    if (typeof path === "object") return;

    urls[definition] = customUrlMap
      ? customUrlMap[path]
      : `${mediaUrl}/dice/bundles/${setName}/${path}`;
  });

  urls["FALLBACK_PIXEL"] = FALLBACK_PIXEL_TEXTURE;
  urls["FALLBACK_DISSOLVE"] =
    `${mediaUrl}/dice/bundles/basic/images/noise-map.png`;

  return useTexture(urls, onLoad);
};
